var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"w-full rounded-md select-none border-transparent focus:border-transparent focus:ring-0 focus:outline-none",class:[
          _vm.getBackgroundColor,
          _vm.loading ? '' : _vm.padding,
          _vm.size,
          {'opacity-50 cursor-not-allowed focus-none': _vm.disabled || _vm.loading}
      ],on:{"click":_vm.onClick}},[_c('div',{staticClass:"flex justify-between gap-y-2"},[(_vm.loading)?_c('div',{staticClass:"mx-auto"},[_c('loading-svg-inline',{staticClass:"w-12 h-12"})],1):_c('span',{staticClass:"flex-grow"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }